import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.StarLorde,
  voices: {
    main: {
      description:
        "flashy space rogue tenor, dance-floor bravado, playful overconfidence, retro headset compression, loose grin with crisp radio consonants",
      seed: 10757,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      {
        id: "select_1",
        text: "Someone's gotta guard the galaxy. Might as well be me.",
      },
      { id: "select_2", text: "Star-Lorde, ready for takeoff." },
      { id: "select_3", text: "Peter Quill, at your service." },
      { id: "select_4", text: "Need help? Call Star-Lorde." },
    ],
    spawn: [
      {
        id: "spawn_1",
        text: "Ready to plant some seeds and reap the rewards!",
      },
      {
        id: "spawn_2",
        text: "It’s like you always say, buddy: I am Groot! Haha!",
      },
      {
        id: "spawn_3",
        text: "Knock me down all you want. I will keep comin’ back!",
      },
      {
        id: "spawn_4",
        text: "Adam? All right! The galaxy’s golden boys are together again!",
      },
      {
        id: "spawn_5",
        text: "I've seen some weird stuff in my day, but this… time hullabaloo. It takes the cake.",
      },
      {
        id: "spawn_6",
        text: "Space, I can protect. But add time to the mix, and things get tricky.",
      },
      {
        id: "spawn_7",
        text: "Yeah. Personally, I think one Doom is way more than enough. Am I right?",
      },
      {
        id: "spawn_8",
        text: "Looks like you're my new Guardians, huh? Guess you'll have to do…",
      },
      { id: "spawn_9", text: "Oh, Drax is gonna be so mad he missed this!" },
      {
        id: "spawn_10",
        text: "I may be from Earth, but every planet's under my protection now.",
      },
      {
        id: "spawn_11",
        text: "I found a family out here in space. And I'll do whatever it takes to keep 'em safe.",
      },
      {
        id: "spawn_12",
        text: "It's time to do the right thing. Just gotta figure out what that is…",
      },
      {
        id: "spawn_13",
        text: "It's an endless universe, but somehow I keep finding the worst parts.",
      },
      {
        id: "spawn_14",
        text: "Got somethin' that needs to be blasted? You called the right guy.",
      },
      {
        id: "spawn_15",
        text: "Right from one cosmic disaster to the next. Story of my life.",
      },
      {
        id: "spawn_16",
        text: "There's only one genuine, certified Star-Lorde… and you're lookin' at him!",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "I'm back, baby!" },
      { id: "respawn_2", text: "Can't keep me down for long!" },
      { id: "respawn_3", text: "No stoppin' the Star-Lorde!" },
      { id: "respawn_4", text: "Let's try this again…" },
    ],
    ult_ally: [{ id: "ult_ally", text: "All right!" }],
    ult_enemy: [
      { id: "ult_enemy_1", text: "Legendary!" },
      {
        id: "ult_enemy_2",
        text: "Happy Holidays! (Starcracker skin-exclusive)",
      },
    ],
    secondary: [
      { id: "secondary_1", text: "Oh! Did you see that?!" },
      { id: "secondary_2", text: "Oh! Thought you had me." },
      { id: "secondary_3", text: "Oh! Sweet moves, right?" },
    ],
    ability2: [
      { id: "ability2_1", text: "Coming right at ya! Haha! Whoo!" },
      { id: "ability2_2", text: "Eat elements, jerks! Hahaha! Whoo!" },
      { id: "ability2_3", text: "3…2…1… Blast off! Ba-Boom." },
    ],
    kill: [
      { id: "kill_1", text: "Two points, Star-Lorde!" },
      { id: "kill_2", text: "I totally rocked that!" },
      { id: "kill_3", text: "In your face, loser!" },
      { id: "kill_4", text: "Who's the man? I am!" },
      { id: "kill_5", text: "Booyah!" },
    ],
    multikill: [
      { id: "multikill_1", text: "That makes three!" },
      { id: "multikill_2", text: "Hat trick!" },
      { id: "multikill_3", text: "He shoots for three… and it's good!" },
      { id: "multikill_4", text: "High five!" },
      { id: "multikill_5", text: "Five! Ho ho! That has to be a record!" },
      { id: "multikill_6", text: "And the hits just KEEP ON COMING!" },
      { id: "multikill_7", text: "THAT WAS all me!" },
      { id: "multikill_8", text: "Talk about an epic run!" },
      { id: "multikill_9", text: "Like I said. Legendary." },
    ],
    low_hp: [
      { id: "low_hp_1", text: "Whew! That was close." },
      { id: "low_hp_2", text: "Needed that boost!" },
    ],
    healed: [
      { id: "healed_1", text: "Whoo! That's the stuff!" },
      { id: "healed_2", text: "Ah! Much better!" },
      { id: "healed_3", text: "Ha! Was lookin' for one of these." },
      { id: "healed_4", text: "Just what the doctor ordered." },
    ],
  },
} satisfies VoiceScript;

export default script;
